/**
 * @generated SignedSource<<a837b550b505aa73941e38626285844a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetTypeNameNode$data = {
  readonly __typename: string;
  readonly entityId: string;
  readonly parentSection?: string | null | undefined;
  readonly topicTypes?: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckCanShowInPlusPlatformArticle" | "helpersCheckIsPlusArticle">;
  readonly " $fragmentType": "helpersGetTypeNameNode";
};
export type helpersGetTypeNameNode$key = {
  readonly " $data"?: helpersGetTypeNameNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetTypeNameNode">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetTypeNameNode"
};

(node as any).hash = "584851a210e26e344effd1c73c60c270";

export default node;
